module.exports = __webpack_public_path__ + "static/media/flybondi.bae13de4.svg";